import { defineStore } from 'pinia'

export const useH104Tab = defineStore('h104Tab', {
  state: () => ({
    selectTab: '',
  }),
  actions: {
    setSelectTab(selectTab: string) {
      this.selectTab = selectTab
    },
    clearSelectTab() {
      this.selectTab = ''
    },
    getSelectTab() {
      return this.selectTab
    }
  }
})
